import Vue from 'vue'
import Button from './button'
import Icon from './icon'
import ButtonGroup from './button-group'
import Input from './input'

Vue.component('g-button', Button)
Vue.component('g-icon', Icon)
Vue.component('g-button-group', ButtonGroup)
Vue.component('g-input',Input)
new Vue({
    el: '#app',
    components: {
        Button,
        Icon
    },
    data: {
        loading1: false
    },
    methods:{
        inputChange(e){
            console.log(e.target.value)
        } 
    }
})